import { cn } from "@/lib/utils";
import { FluentIcon } from "@fluentui/react-icons";
import { NavLink } from "react-router-dom";

interface SidebarItemProps {
  label: string;
  href: string;
  Icon: FluentIcon;
}

function SidebarItem({ label, href, Icon }: SidebarItemProps) {
  return (
    <NavLink to={href}>
      {({ isActive }) => (
        <div
          className={cn(
            "flex h-[38px] cursor-pointer items-center gap-3 p-2",
            isActive ? "rounded-[6px] bg-cyan-600" : "",
          )}
        >
          <Icon
            className={cn(isActive ? "text-white" : "text-cyan-600")}
            fontSize={20}
          />
          <div
            className={cn(
              "font-bold",
              isActive ? "text-white" : "text-cyan-600",
            )}
          >
            {label}
          </div>
        </div>
      )}
    </NavLink>
  );
}

export default SidebarItem;
